import React, { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { usePushNotifications } from '../hooks/usePushNotifications';

const NotificationBanner = () => {
  const { permission, isSubscribed, isSupported, subscribe } = usePushNotifications();
  const [dismissed, setDismissed] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Show banner after 5 seconds if user hasn't subscribed and hasn't dismissed
    const wasDismissed = sessionStorage.getItem('pushBannerDismissed');
    if (isSupported && !isSubscribed && permission !== 'denied' && !wasDismissed) {
      const timer = setTimeout(() => setShow(true), 5000);
      return () => clearTimeout(timer);
    }
  }, [isSupported, isSubscribed, permission]);

  const handleSubscribe = async () => {
    const success = await subscribe();
    if (success) {
      setShow(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    setShow(false);
    sessionStorage.setItem('pushBannerDismissed', 'true');
  };

  if (!show || dismissed) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-[340px] z-[60] bg-white border border-slate-200 rounded-xl shadow-lg p-4 animate-in slide-in-from-bottom-4"
      data-testid="push-notification-banner"
    >
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 text-slate-400 hover:text-slate-600 p-1"
        data-testid="dismiss-push-banner"
      >
        <X className="w-4 h-4" />
      </button>
      <div className="flex gap-3">
        <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
          <Bell className="w-5 h-5 text-church-green" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-slate-900 mb-0.5">Stay Connected</p>
          <p className="text-xs text-slate-500 mb-3 leading-relaxed">
            Get updates on services, events, and church news delivered to your device.
          </p>
          <button
            onClick={handleSubscribe}
            className="w-full py-2 bg-church-green text-white text-sm font-medium rounded-lg hover:bg-church-green-dark transition-colors"
            data-testid="enable-push-btn"
          >
            Enable Notifications
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationBanner;
